module.exports = __webpack_public_path__ + "img/currency.ae6abcc7.jpg";